export const ACTION_COLOR_MAP = {
  default: 'default',
  danger: 'white',
  primary: 'white',
  success: 'white',
  warning: 'black',
  upgrade: 'white',
};

export const TOAST_MAX_WIDTH = 500;

/**
 * Note max-width - icon width - close button width - flex gaps
 */
export const TOAST_CONTENT_MAX_WIDTH = 420;
